import serviceJava from "../utils/requestJava";

export default {
  getLiveReport: (params) =>
    serviceJava.post(`/ess-live-api/unionLive/do/preview`, params), // 获取直播列表
};
